<template>
  <vs-prompt
    :title="'Delete Automation: ' + this.automationName"
    color="danger"
    :is-valid="checkvalidation"
    @accept="deleteAutomation"
    @close="clearFields"
    :active.sync="showDeletePrompt"
    accept-text="Yes, Delete"
  >
    <vs-alert active="true" color="danger"
      >You are about to delete <b>{{ automationName }}</b
      >. This operation is irreversible, to proceed enter the automation name below.
    </vs-alert>
    <vs-input label="Automation Name" placeholder="Confirm automation name" v-model="confirmAutomationName" class="my-2 w-full mb-4" />
  </vs-prompt>
</template>

<script>
// import firebase from 'firebase/app'
import 'firebase/firestore'
import firebase from 'firebase'

export default {
  name: 'automationRemover',
  data() {
    return {
      showDeletePrompt: false,
      automationName: '',
      confirmAutomationName: '',
    }
  },
  computed: {
    checkvalidation() {
      if (this.confirmAutomationName === this.automationName) return true
      else return false
    },
  },
  methods: {
    deleteAutomationToggler(automationName) {
      this.showDeletePrompt = true
      this.automationName = automationName
    },
    async deleteAutomation() {
      await firebase
        .firestore()
        .collection('cloudify')
        .doc(JSON.parse(localStorage.getItem('userInfo')).uid)
        .set(
          {
            sheets: {
              [`${this.automationName}`]: firebase.firestore.FieldValue.delete(),
            },
          },
          { merge: true }
        )

      // Delete entry from real time database
      const reference = firebase
        .database()
        .ref(JSON.parse(localStorage.getItem('userInfo')).database)
        .child(`${this.automationName}`)

      reference.remove()
      this.clearFields()
    },
    clearFields() {
      this.confirmAutomationName = ''
    },
  },
}
</script>

<style scoped></style>
